<div class="logo">
  <img [src]="'assets/images/logo.svg'">
  ¡Nueva actualización de ControlCar!
  <p>(Actual: {{actualVersion}}, Navegador: {{usingVersion}}) </p>
  <button mat-raised-button color="accent" (click)="deleteCaches()">Actualizar aplicación.</button>
  <button mat-raised-button color="primary" (click)="close()">Actualizar mas tarde.</button>

</div>
